import React from "react";
import ResponsiveLayout from "../../common_components/ResponsiveLayout";
import AboutMobile from "./mobile/AboutMobile";
import AboutDesktop from "./desktop/AboutDesktop";

const About = () => {
  return (
    <ResponsiveLayout
      MobileComponent={AboutMobile}
      DesktopComponent={AboutDesktop}
    />
  );
};

export default About;
